interface IconProps {
  className?: string;
}

/** Info-in-circle glyph from the DubaiExpress product page mockup (trust links under the title). */
const InfoCircleIcon = ({ className }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    className={className}
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8h.01M11 12h1v4h1" />
  </svg>
);

export default InfoCircleIcon;
